/**
 * ⌘K command palette state. Items are registered by individual screens —
 * the palette itself only handles the open/close state and keybinding.
 *
 * Phase 0 wires the global toggle. Real fuzzy search over customers /
 * vehicles / job numbers / parties (§15.9.H) lands in Phase 2.
 */
import { ref, onMounted, onUnmounted } from "vue";

export interface PaletteItem {
  id: string;
  label: string;
  hint?: string;
  group?: string;
  perform: () => void;
}

const open = ref(false);
const items = ref<PaletteItem[]>([]);

function isMac() {
  return typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/i.test(navigator.platform);
}

function handleKey(e: KeyboardEvent) {
  const cmdOrCtrl = isMac() ? e.metaKey : e.ctrlKey;
  if (cmdOrCtrl && e.key.toLowerCase() === "k") {
    e.preventDefault();
    open.value = !open.value;
  } else if (e.key === "Escape" && open.value) {
    open.value = false;
  }
}

export function useCommandPalette() {
  onMounted(() => {
    window.addEventListener("keydown", handleKey);
  });
  onUnmounted(() => {
    window.removeEventListener("keydown", handleKey);
  });

  function register(newItems: PaletteItem[]) {
    items.value = [...items.value.filter((i) => !newItems.find((n) => n.id === i.id)), ...newItems];
  }
  function clear(ids: string[]) {
    items.value = items.value.filter((i) => !ids.includes(i.id));
  }
  return { open, items, register, clear };
}
